import { UserIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import type { Person } from '@/types/person';
import { ThumbnailWithPreview } from '../ThumbnailWithPreview';

interface SelectedPersonProps {
    person: Person;
    sectionLabel?: string;
    imageUrlOverride?: string;
    nameOverride?: string;
}

export function SelectedPerson({
    person,
    sectionLabel,
    imageUrlOverride,
    nameOverride,
}: SelectedPersonProps) {
    const { t } = useTranslation(I18nNamespace.DIRECTORY);

    const label = sectionLabel ?? t('mergeIdentityModal.selectedIdentity');
    const imageUrl =
        imageUrlOverride !== undefined
            ? imageUrlOverride
            : (person.imageUrl ?? null);
    const displayName =
        nameOverride ?? person.name ?? t('mergeIdentityModal.unknownPerson');

    return (
        <div className="flex flex-col gap-3 rounded-lg bg-grey-600 px-3 py-3">
            <span className="text-sm text-grey-300">{label}</span>
            <div className="flex items-center gap-3 rounded-md bg-grey-700 px-3 py-2">
                <ThumbnailWithPreview
                    imageUrl={imageUrl}
                    name={displayName}
                    fallbackIcon={
                        <UserIcon className="text-grey-300" size={28} />
                    }
                />
                <div className="min-w-0 flex-1">
                    <p className="truncate text-sm-medium text-white-100">
                        {displayName}
                    </p>
                </div>
            </div>
        </div>
    );
}
